export default __webpack_public_path__ + "file-asset/a14138a2721b1e105efa4b909a055617-community.svg";